import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "../common/Select";

const mapStateToProps = (state) => {
    return {
        region: state.modelAreaReducer.region,
        paramRegion: state.paramReducer.region,
        paramEnv: state.paramReducer.env,
    };
};

/*
 * 説明変数選択
 * @since hara 2021-02-10
 */
class ExVar extends Component {
    constructor(props) {
        super(props);
        this.exVarCatOpt = [];
        this.changeExVarCat = this.changeExVarCat.bind(this);
        this.changeExVarName = this.changeExVarName.bind(this);

        //説明変数種別オプション作成
        const env = this.props.paramRegion[this.props.region].env;
        Object.keys(env).forEach((key, index) => {
            if (index === 0) this.props.dispatch(this.props.exVarCatAction(key));
            if (env[key].length) this.exVarCatOpt.push({ val: key, text: key });
        });

        this.createExVarNameOpt();
    }

    componentDidUpdate(prevProps) {
        /*
         * 説明変数種別変更の場合
         * @since hara 2021-06-22
         */
        if (prevProps.exVarCat !== this.props.exVarCat) {
            this.createExVarNameOpt();
        }
    }

    /*
     * 説明変数名称オプション作成
     * @since hara 2021-06-22
     */
    createExVarNameOpt() {
        let opt = [];
        const exVar = this.props.paramRegion[this.props.region].env[this.props.exVarCat];
        exVar.forEach((el, index) => {
            if (index === 0) this.props.dispatch(this.props.exVarNameAction(el));
            opt.push({ val: el, text: this.props.paramEnv[this.props.exVarCat][el].name });
        });

        this.props.dispatch(this.props.exVarNameOptAction(opt));
    }

    /*
     * Selectコンポーネント内の関数でdispatchできない不具合で仮に下の関数を渡す******
     * @since hara 2021-06-24
     */
    changeExVarCat(e) {
        this.props.dispatch(this.props.exVarCatAction(e.target.value));
    }
    changeExVarName(e) {
        this.props.dispatch(this.props.exVarNameAction(e.target.value));
    }

    render() {
        return (
            <div>
                <Select label="説明変数種別" options={this.exVarCatOpt} value={this.props.exVarCat} action={null} change={this.changeExVarCat} class="selectM" blank={false} mt={true} />
                <Select label="説明変数名称" options={this.props.exVarNameOpt} value={this.props.exVarName} action={null} change={this.changeExVarName} class="selectM" blank={false} mt={true} />
            </div>
        );
    }
}

export default connect(mapStateToProps)(ExVar);
